import { Component, OnInit } from '@angular/core';
import { SettingService } from '../services/setting.service';
import { Router } from '@angular/router';
import { AccountService } from '../services/account.service';
import { User } from '../models/user';
import { TierService } from '../services/tier.service';
import { WalletSummaryModel } from '../models/walletSummaryModel';
declare var $: any;


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {


  constructor(
    public settingService: SettingService,
    public router: Router,
    public accountService: AccountService,
    private tierService:TierService
  ) {


  }
  walletSummary: WalletSummaryModel=new WalletSummaryModel();
  userMobileNumber:string;
  ngOnInit() {

    $(document).ready(function() {
      var navTrigger = document.getElementsByClassName('nav-trigger')[0],
      body = document.getElementsByTagName('body')[0];

    navTrigger.addEventListener('click', toggleNavigation);

    function toggleNavigation(event) {
      event.preventDefault();
      body.classList.toggle('nav-open');
    }

    $(window).scroll(function(){
      if ($(window).scrollTop() >= 26) {
          $('.balance').addClass('fixed-header');
          $('.nav-fixed').addClass('nav-fixed-2');
          // $('nav div').addClass('visible-title');
      }
      else {
          $('.balance').removeClass('fixed-header');
          $('.main-content').addClass('fixed-header2');
          $('.nav-fixed').removeClass('nav-fixed-2');
          // $('nav div').removeClass('visible-title');
      }
    });

    });
    this.getSummary();

  }
  changeLanguage(lang) {
    this.settingService.useLanguage(lang);
  }
  signOut() {
    const lang = localStorage.getItem('lang');
    this.accountService.signOut();
    this.settingService.user=new User();
    localStorage.lang = lang;
    this.router.navigate(['/login']);
  }

  getSummary()
  {
    this.settingService.getValueObservable().subscribe(value => this.userMobileNumber = value);
    this.settingService.walletSummary.subscribe(res=>{
      this.walletSummary=res;
    });
    if(this.walletSummary.totalPoints==undefined && this.accountService.isUserLoggedIn()){
      this.tierService.getWalletSammary().subscribe(res=>{
        localStorage.walletId=res.walletId;
        this.walletSummary=res;
        this.settingService.setWalletSummary(res);
      });
    }

  }

   // this.settingService.getUserInfoFromToken(localStorage.token);
    // this.tierService.getWalletSammary(this.settingService.user.mobileNumber).subscribe(res=>{
    //   console.log(res);
    //   localStorage.walletId=res.walletId;
    //   this.walletSummary=res
    //   this.settingService.setWalletSummary(this.walletSummary);

    // }, error => {
    //   // this.walletSummary.totalPoints=this.settingService.user.balance;
    //   // this.walletSummary.totalValue=this.settingService.user.pointsValue;
    //   // this.settingService.setWalletSummary(this.walletSummary);

    // });




}
